import {
  formatReferrer,
  type ReferrerType,
} from '@on3/ui-lib/utils/formatters';
import { hashEmail } from '@on3/ui-lib/utils/user';

/**
 * Get author_ref_key from session storage (set in ArticleProvider.tsx when article loads)
 */
const getAuthorRefKey = (): number | null => {
  if (typeof window === 'undefined') return null;
  const authorRefKey = sessionStorage?.getItem('author_ref_key');

  return authorRefKey
    ? JSON.parse(authorRefKey, (k, v) => (v === 'null' ? null : +v))
    : null;
};

/**
 * Get content_ref_key from session storage (set in ArticleProvider.tsx when article loads)
 */
const getContentRefKey = (): number | null => {
  if (typeof window === 'undefined') return null;
  const contentRefKey = sessionStorage?.getItem('content_ref_key');

  return contentRefKey
    ? JSON.parse(contentRefKey, (k, v) => (v === 'null' ? null : +v))
    : null;
};

/**
 * Get the site referrer (set in _app.tsx)
 */
const getReferrer = (): ReferrerType => {
  if (typeof window === 'undefined') return 'unknown';

  return (
    (sessionStorage?.getItem('referrer') as ReferrerType) ||
    formatReferrer(document.referrer) ||
    'other'
  );
};

/**
 * Get the site user_agent (set in _app.tsx)
 */
const getUserAgent = () => {
  if (typeof window === 'undefined') return null;

  return sessionStorage?.getItem('user_agent') || navigator.userAgent || null;
};

const trackGoogle = async (event: string, params: Record<string, unknown>) => {
  if (!window || !('dataLayer' in window)) return;

  try {
    // If params contains email, hash it for privacy
    if (params.email || params.userEmail) {
      const email = (params.email || params.userEmail) as string;
      const hashedEmail = await hashEmail(email);

      delete params.email;
      delete params.userEmail;
      params.email = hashedEmail;
    }

    window.dataLayer.push({
      event,
      ...params,
    });
  } catch (_e) {
    // Fail silently
  }
};

export {
  getAuthorRefKey,
  getContentRefKey,
  getReferrer,
  getUserAgent,
  trackGoogle,
};
